import api from '../config/axios-conf';

export const getEmployees = () =>
    api.get('/employees/employeeAll');

export const getDeletedEmployees = () =>
    api.get('/employees/employeeAllDeleted');

export const getEmployee = (id) =>
    api.get(`/employees/${id}`);

export const getEmployeeByUser = (userId) =>
    api.get(`/employees/user/${userId}`);

export const createEmployee = (data) =>
    api.post('/employees/create-with-user', data);

export const getPermissionList = () =>
    api.get('/permissions');

export const updateEmployee = (id, data) =>
    api.put(`/employees/${id}`, data);

export const deleteEmployee = (id) =>
    api.delete(`/employees/${id}`);

export const restoreEmployee = (id) =>
    api.post(`/employees/${id}/restore`);

export const getEmployeePay = (id, params) =>
    api.get(`/employees/${id}/pay`, { params });

export const getEmployeeBillsDetail = (id, params) =>
    api.get(`/employees/${id}/bills-detail`, { params });

export const getAllPayroll = (params) =>
    api.get('/employees/payAll', { params });

export const getSupportEmployees = () =>
    api.get('/employees/supportEmployeeAll');

export const getUserById = (employeeId) =>
    api.get(`/users/${employeeId}`);

export const updateUser = (userId, data) =>
    api.put(`/users/${userId}`, data);

export const getShiftTypes = () =>
    api.get('/shift-types/all');
